import React, { createContext, useState } from "react"

export const CollapseContext = createContext(null)

export default ({ children }) => {
  const [collapse, setCollapse] = useState({})

  const toggleCollapse = collapseId => {
    const copy = { ...collapse }
    if (copy[collapseId] === undefined) {
      copy[collapseId] = true
    } else if (copy[collapseId] === true) {
      copy[collapseId] = false
    } else if (copy[collapseId] === false) {
      copy[collapseId] = true
    }
    setCollapse(copy)
  }

  const isOpen = collapseId => {
    if (collapse[collapseId] === undefined) return false
    return collapse[collapseId]
  }
  const setDefault = (collapseId, value) => {
    if (value === true && collapse[collapseId] === undefined) {
      collapse[collapseId] = value
    }
  }

  return (
    <CollapseContext.Provider
      value={{ collapse, toggleCollapse, setDefault, isOpen }}
    >
      {children}
    </CollapseContext.Provider>
  )
}
